import dynamic from 'next/dynamic';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });
const NewsEventContent = dynamic(() => import('../components/static/aboutPage/newsEvents/news'), { loading: () => <></>, ssr: true });
import { withRouter } from 'next/router';
import {getNewsEventPageData} from "../api/news_event";

function NewsEvent(props) {
	const meta = {
		title: "News events | Bayan in the media | Welcome to Bayan | Bayan",
		description: "Netflix for Islamic studies #covid19 #stayhome #onlinelearning Register today @bayanonline.org Our president Jihad Turk comments in this timely article on online prayer platforms for religious communities.",
		route: "news-events",
	}
	return (
		<>
			<Layout theme={props.theme} meta={meta}>
				<NewsEventContent router={props.router} newsEventPageData={props?.newsEventPageData ?? ''} />
			</Layout>
		</>
	);
}

export async function getServerSideProps(ctx) {
	const newsEventPageData = await getNewsEventPageData();
	// console.log(newsEventPageData);
	return { props: { newsEventPageData: newsEventPageData ?? '' } }
}
export default withRouter(NewsEvent);
